import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { ChevronDown as h } from "@hagerty/icons";
import t from "clsx";
import o, { useState as v } from "react";
import { useEscKeyListener as y } from "../../hooks/useEscKeyListener";
import { useOnClickOutside as _ } from "../../hooks/useOnClickOutside";

var k = function k(r) {
  return "items" in r;
};

function L(_ref) {
  var r = _ref.children,
      s = _ref.items,
      n = _ref.isOpen,
      c = _ref.handleToggle,
      d = _ref.handleClose,
      l = _objectWithoutProperties(_ref, ["children", "items", "isOpen", "handleToggle", "handleClose"]);

  var _v = v(null),
      _v2 = _slicedToArray(_v, 2),
      p = _v2[0],
      u = _v2[1];

  return _({
    current: p
  }, d, "on-click-outside"), y(n, d), o.createElement(o.Fragment, null, o.createElement("button", _objectSpread({
    type: "button",
    className: t("hg-secondarynav__dropdown-button", "on-click-outside", {
      "hg-secondarynav__dropdown--open": n
    }),
    onClick: c,
    "aria-haspopup": !0,
    "aria-expanded": n
  }, l), r, o.createElement(h, {
    className: "hg-secondarynav__dropdown-button-icon",
    width: 14,
    height: 14
  })), o.createElement("div", {
    ref: u,
    className: t("hg-secondarynav__dropdown-container", "on-click-outside", {
      "hg-secondarynav__dropdown--open": n
    }),
    "aria-hidden": !n
  }, o.createElement("ul", {
    className: "hg-secondarynav__dropdown-items"
  }, s.map(function (_ref2, m) {
    var a = _ref2.openInNewTab,
        e = _objectWithoutProperties(_ref2, ["openInNewTab"]);

    var i;
    return o.createElement("li", {
      key: (i = e.id) != null ? i : m
    }, o.createElement("a", _objectSpread(_objectSpread({}, e), {}, {
      className: t("hg-secondarynav__dropdown-item-link", e.className),
      target: a ? "_blank" : void 0,
      rel: a ? "noopener noreferrer" : void 0
    }), e.children));
  }))));
}

export { L as SecondaryNavDropdown, k as isDropdown };